import * as tslib_1 from "tslib";
import React from 'react';
import Field, { FastField } from './Field';
export default function withField(config) {
    if (config === void 0) { config = { fast: false }; }
    var FieldComponent = config.fast ? FastField : Field;
    return function (InputComponent) { return function (_a) {
        var children = _a.children, formik = _a.formik, props = tslib_1.__rest(_a, ["children", "formik"]);
        return (React.createElement(FieldComponent, tslib_1.__assign({}, props, { render: function (_a) {
                var field = _a.field, form = _a.form;
                return (React.createElement(InputComponent, { inputProps: props, field: field, form: form, value: field.value, onChange: field.onChange, name: props.name, symbol: props.symbol, monitorOpen: props.monitorOpen, monitorOpenValue: props.monitorOpenValue, error: form.touched[field.name] && form.errors[field.name] }, children));
            } })));
    }; };
}
//# sourceMappingURL=withField.js.map